import { System } from 'src/app/@framework/core/clms.fw.dotnet';
import * as Domain from '../Domain';
import * as Common from '../../@framework/common';
import { CLMS  } from 'src/app/@framework/core/clms.fw.common';
import { Joove } from 'src/app/@framework/core/Joove';
import * as moment from 'moment';
import { TranslateService } from '@ngx-translate/core';
import { DataListColumnInfo, DataListColumnItemType, ListDynamicColumnValue } from '@framework/components/DataList/helpers/List.helper.classes';
import { ValueFormat } from '@framework/core/clms.fw.angular';
var numeral = require('numeral');
const VerEx = require('verbal-expressions');


export class BankAccountListExporter  {
    _originalTypeClassName = "zERP.BO.BankAccountListExporter";
constructor(protected translateService: TranslateService = null) {
if (translateService != null) {
BankAccountListExporter.translate = translateService;
}
this.BankAccountListExporterKey = null;
this._key = this.BankAccountListExporterKey = 0; 
}

static translate: TranslateService;
_key: any;
private _BankAccountListExporterKey:any;
get BankAccountListExporterKey(): any {
    return this._BankAccountListExporterKey;
  }
set BankAccountListExporterKey(value: any) {
    this._BankAccountListExporterKey = value;
    this._key = value;
  }


static IsNew($this: any): boolean {
                if ($this == null) return true;
                return $this.BankAccountListExporterKey == null || $this.BankAccountListExporterKey == 0;
            }


}